module.exports = __webpack_public_path__ + "static/assets/material-symbols_asterisk.svg";